module.exports = __webpack_public_path__ + "img/home_pic_3.5_2.4cdbb6c6.webp";